import React from 'react';
export function Footer() {
  return <footer className="bg-[#020617] border-t border-[#22c55e]/20 py-8 px-4 text-center" data-id="element-164">
      <div className="max-w-3xl mx-auto" data-id="element-165">
        <div className="inline-flex items-center gap-2 text-[#22c55e] font-black text-xl mb-4" data-id="element-166">
          <span data-id="element-167">🚴</span> TU MANUAL DIGITAL™
        </div>

        <p className="text-[#e2e8f0] mb-6 max-w-md mx-auto font-medium" data-id="element-168">
          El sistema de ciclismo N°1 para el ciclista amateur argentino.
        </p>

        <div className="flex flex-col items-center gap-2 text-sm text-[#475569] mb-8 font-bold" data-id="element-169">
          <a href="mailto:soporte.tumanualdigital@gmail.com" className="hover:text-[#22c55e] transition-colors" data-id="element-170">
            📧 soporte.tumanualdigital@gmail.com
          </a>
          <a href="https://www.tumanualdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#22c55e] transition-colors" data-id="element-171">
            🌐 www.tumanualdigital.com
          </a>
        </div>

        <div className="text-xs text-[#475569] space-y-2 font-medium" data-id="element-172">
          <p data-id="element-173">© Tu Manual Digital™ · Todos los derechos reservados</p>
          <p className="italic" data-id="element-174">"La próxima salida puede ser diferente." 🚴</p>
        </div>
      </div>
    </footer>;
}